import { ICredentialTypeFilter } from '../filters/CredentialTypeFilter';
import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { OAuthCredentials } from '../resources/OAuthCredentials';
import { IOAuthCredential } from '../ServerApi/types/IOAuthCredential';
import { IOAuthCredentialsService } from '../services/OAuthCredentialsService';
import { AbstractContentAction } from './AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export class DeleteOAuthCredentialsAction extends AbstractContentAction<IOAuthCredential> {

  public static $inject = ['ConfirmActionDialog', 'ContentActionNotification', '$translate', '$filter', 'OAuthCredentials', 'OAuthCredentialsService'];

  constructor(
            ConfirmActionDialog: ConfirmActionDialog,
            ContentActionNotification: ContentActionNotification,
    private $translate: ng.translate.ITranslateService,
    private $filter: ng.IFilterService,
    private OAuthCredentials: OAuthCredentials,
    private oAuthCredentialsService: IOAuthCredentialsService
  ) {
    super(ConfirmActionDialog, ContentActionNotification);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, oauthCredentials: Set<IOAuthCredential>) {
    const dialogBody = oauthCredentials.size() === 1
      ? this.$translate.instant('confirmDeleteOAuthCredential', {
          USERNAME: L10n.elideIfLong(oauthCredentials.first().username),
          TRANSLATED_TYPE: this.$filter<ICredentialTypeFilter>('credentialType')(
            this.oAuthCredentialsService.getTypeInfo(oauthCredentials.first().type))
        })
      : this.$translate.instant('confirmDeleteOAuthCredentials', { CREDENTIAL_COUNT: oauthCredentials.size() }, L10n.Interpolations.Count);

    dialogConfig.bodyText = dialogBody;
    dialogConfig.title = this.$translate.instant('deleteMessage');
    dialogConfig.actionName = this.$translate.instant('confirmDeleteButton', { ITEM_COUNT: oauthCredentials.size() }, L10n.Interpolations.Count);
    dialogConfig.isDeleteAction = true;
    dialogConfig.action = () => this.OAuthCredentials.del(oauthCredentials.keys());
  }

  notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'deleteOAuthCredentialsSuccess',
      errorId: 'deleteOAuthCredentialsError'
    };
  }

}

Module.instance().service('DeleteOAuthCredentialsAction', DeleteOAuthCredentialsAction);
